import { forwardRef, type MouseEventHandler } from "react";

import { Icon_TriangleDown } from "@shapr3d/frontend-lib";

import { Avatar } from "../../../Comment/Avatar";

import style from "./AccountButton.module.css";

type AccountButtonProps = {
  name?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  isCompact?: boolean;
};

export const AccountButton = forwardRef<HTMLDivElement, AccountButtonProps>(
  ({ name, onClick, isCompact }, ref) => {
    return (
      <div ref={ref} className={style.emailAvatarContainer} onClick={onClick}>
        <Avatar title={name ?? "Unknown user"} />
        {!isCompact && (
          <div className={style.emailContainer}>
            <span className={style.email}>{name ?? "Unknown user"}</span>
            <Icon_TriangleDown />
          </div>
        )}
      </div>
    );
  }
);
AccountButton.displayName = "AccountButton";
